import React from "react";
import { Route, Routes } from "react-router-dom";
import MyTable from "./pages/MyTable";
import ShareTable from "./pages/ShareTable";
import EditTable from "./pages/EditTable";
import MainLayout from "../../layouts/MainLayout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import WithdrawPageStep1 from "./pages/WithdrawPage/WithdrawPageStep1";
import WithdrawPageStep2 from "./pages/WithdrawPage/WithdrawPageStep2";
import WithdrawPageStep3Manual from "./pages/WithdrawPage/WithdrawPageStep3Manual";
import WithdrawPageStep4Manual from "./pages/WithdrawPage/WithdrawPageStep4Manual";
import WithdrawPageStep5ManualReview from "./pages/WithdrawPage/WithdrawPageStep5ManualReview";
import WithdrawPageStep6ManualSuccess from "./pages/WithdrawPage/WithdrawPageStep6ManualSuccess";
import WithdrawPageStep3 from "./pages/WithdrawPage/WithdrawPageStep3";
import WithdrawPageStep4 from "./pages/WithdrawPage/WithdrawPageStep4";
import WithdrawPageStep5 from "./pages/WithdrawPage/WithdrawPageStep5";
import WithdrawPageSuccess from "./pages/WithdrawPage/WithdrawPageSuccess";
import ChoosePlan from "./pages/ChoosePlan";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PrepayPage from "./pages/PrepayPage";
import Gifts from "./pages/Gifts"; // Import the Gifts component
import { useMediaQuery } from "react-responsive";
import SingleGiftDetail from "./components/GiftDetail/index";
import MyProducts from "./pages/MyProducts";
import Products from "./pages/Products";
import ThankYouMessageSuccess from "./pages/ThankYouMessageSuccess";
import ThankYouMessagePage from "./pages/ThankYouMessagePage";
import DonationReceiptStep1 from "./pages/DonationReceipt/DonationReceiptStep1";
import DonationReceiptStep2 from "./pages/DonationReceipt/DonationReceiptStep2";
import DonationReceiptStep3 from "./pages/DonationReceipt/DonationReceiptStep3";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const MyGiftTableRouter: React.FC = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const renderWithLayout = (component: React.ReactElement) => {
    return isMobile ? component : <MainLayout>{component}</MainLayout>;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <MyTable />
          </MainLayout>
        }
      />
      <Route
        path="/my-products"
        element={
          <MainLayout>
            <MyProducts />
          </MainLayout>
        }
      />
      <Route
        path="/products"
        element={
          <MainLayout>
            <Products />
          </MainLayout>
        }
      />
      <Route
        path="/choose-plan"
        element={
          <MainLayout>
            <ChoosePlan />
          </MainLayout>
        }
      />
      <Route
        path="/prepay"
        element={
          <MainLayout>
            <Elements stripe={stripePromise}>
              <PrepayPage />
            </Elements>
          </MainLayout>
        }
      />
      <Route
        path="/payment-success"
        element={
          <MainLayout>
            <PaymentSuccessPage />
          </MainLayout>
        }
      />

      <Route path="/share" element={renderWithLayout(<ShareTable />)} />
      <Route path="/edit" element={renderWithLayout(<EditTable />)} />
      <Route path="/gifts" element={renderWithLayout(<Gifts />)} />
      <Route
        path="/gift/:giftId"
        element={renderWithLayout(<SingleGiftDetail />)}
      />
      <Route
        path="/gift/:giftId/thankyoumessage"
        element={renderWithLayout(<ThankYouMessagePage />)}
      />
      <Route
        path="/gift/:giftId/thankyoumessage/success"
        element={renderWithLayout(<ThankYouMessageSuccess />)}
      />

      {/* Withdraw journey */}
      <Route
        path="/withdraw/step1"
        element={
          <MainLayout>
            <WithdrawPageStep1 />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step2"
        element={
          <MainLayout>
            <WithdrawPageStep2 />
          </MainLayout>
        }
      />

      <Route
        path="/withdraw/step3-manual"
        element={
          <MainLayout>
            <WithdrawPageStep3Manual />
          </MainLayout>
        }
      />

      <Route
        path="/withdraw/step3"
        element={
          <MainLayout>
            <WithdrawPageStep3 />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step4-manual"
        element={
          <MainLayout>
            <WithdrawPageStep4Manual />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step5-manual"
        element={
          <MainLayout>
            <WithdrawPageStep5ManualReview />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step6-manual"
        element={
          <MainLayout>
            <WithdrawPageStep6ManualSuccess />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step4"
        element={
          <MainLayout>
            <WithdrawPageStep4 />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/step5"
        element={
          <MainLayout>
            <WithdrawPageStep5 />
          </MainLayout>
        }
      />
      <Route
        path="/withdraw/success"
        element={
          <MainLayout>
            <WithdrawPageSuccess />
          </MainLayout>
        }
      />

      <Route
        path="/sign-donation-receipt/:withdrawId"
        element={
          <MainLayout>
            <DonationReceiptStep1 />
          </MainLayout>
        }
      />

      <Route
        path="/sign-donation-receipt/:withdrawId/step2"
        element={
          <MainLayout>
            <DonationReceiptStep2 />
          </MainLayout>
        }
      />

      <Route
        path="/sign-donation-receipt/:withdrawId/step3"
        element={
          <MainLayout>
            <DonationReceiptStep3 />
          </MainLayout>
        }
      />
    </Routes>
  );
};

export default MyGiftTableRouter;
